class DeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    const start = parseInt(this.dataset.start, 10);
    const end = parseInt(this.dataset.end, 10);
    const template = this.dataset.template;

    if (!template || Number.isNaN(start) || Number.isNaN(end)) return;

    this.textContent = template
      .replace('%start%', this.formatDate(start))
      .replace('%end%', this.formatDate(end));
  }

  formatDate(days) {
    const date = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
    const options = { weekday: 'short', day: 'numeric', month: 'short' };
    const locale = document.documentElement.lang;

    try {
      return date.toLocaleDateString(locale || undefined, options);
    } catch (e) {
      return date.toLocaleDateString(undefined, options);
    }
  }
}

if (!customElements.get('delivery-estimate')) {
  customElements.define('delivery-estimate', DeliveryEstimate);
}
